import { SaveIndicatorType } from '@axinom/mosaic-shared-components';
import { initializeUi } from '@axinom/mosaic-ui';
import React, { type Reducer, useEffect, useReducer } from 'react';
import { TitleSuffix } from './constants';

const initialState = {
  saveIndicatorType: SaveIndicatorType.Inactive,
};

// using a type here, so we can `|` new actions later
// eslint-disable-next-line prettier/prettier, @typescript-eslint/consistent-type-definitions
interface SetSaveIndicatorAction {
  type: 'setSaveIndicatorType';
  payload: SaveIndicatorType;
}

type ActionType = SetSaveIndicatorAction; // | new actions

const reducer: Reducer<typeof initialState, ActionType> = (state, action) => {
  switch (action.type) {
    case 'setSaveIndicatorType':
      return { ...state, saveIndicatorType: action.payload };
    default:
      return state;
  }
};

export const UIContext = React.createContext(initialState);

export const UIContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    initializeUi({
      showNotification: () => {
        // not implemented
        return -1;
      },
      addIndicator: () => {
        return -1;
      },
      removeIndicator: () => {
        // not implemented
      },
      on: () => {
        // not implemented
      },
      setSaveIndicator: (type: SaveIndicatorType) => {
        dispatch({ type: 'setSaveIndicatorType', payload: type });
      },
      setTitle: (content) => {
        window.document.title = content + ' - ' + TitleSuffix;
      },
    });
  }, []);

  return <UIContext.Provider value={state}>{children}</UIContext.Provider>;
};
